import type { FC } from 'react';

import type { SECTION } from 'src/constants/section';
import usePageTracking from 'src/hooks/usePageTracking';

export interface PageTrackingProps {
  section: SECTION;
  route: string;
}

const PageTracking: FC<PageTrackingProps> = ({ section, route }) => {
  usePageTracking(section, route);

  return null;
};

export default PageTracking;
